import { ProfileOnGetProfileFragment, QuestionDetailFragment } from "../../graphql/generated/graphql"
import ProfilePhoto, { Width } from "../../components/profilePhoto"
import React, { ReactElement } from "react"
import tw from "twin.macro"
import { Button } from "../../components/formElements/button"
import router from "next/router"
import { Routes } from "../../routes"
import Link from "next/link"

interface TextCellProps {
  text: string
}

interface UserCellProps {
  user: ProfileOnGetProfileFragment
}

interface QuestionCellProps {
  question: QuestionDetailFragment | null
}

interface IconCellProps {
  iconLinks: Array<ReactElement>
}

export const TextTableCell = ({ text }: TextCellProps) => {
  return (
    <div tw="flex items-center justify-center w-40">
      <p tw="text-sm font-semibold text-center">{text}</p>
    </div>
  )
}

export const IconTableCell = ({ iconLinks }: IconCellProps) => {
  return (
    <div tw="flex items-center justify-center w-40">
      <div tw="flex flex-row gap-2">{iconLinks}</div>
    </div>
  )
}

export const UserTableCell = ({ user }: UserCellProps) => {
  const { username, name, profilePictureUrl, verified } = user
  return (
    <div tw="flex flex-row items-center justify-start w-40 pb-1">
      <ProfilePhoto
        name={name ?? ""}
        username={username}
        width={Width.W24}
        profilePictureUrl={profilePictureUrl}
        showVerified={verified}
      />
      <Link href={`/${username}`}>
        <a tw="text-sm pl-2 font-semibold hover:underline">{username}</a>
      </Link>
    </div>
  )
}

export const QuestionTableCell = ({ question }: QuestionCellProps) => {
  if (!question) {
    return <></>
  }
  const { id } = question
  return (
    <div tw="flex flex-row items-center w-40 pb-2">
      <Button
        action="view question"
        onClickAsync={async () =>
          void router.push({
            pathname: Routes.ShowQuestion,
            query: { id },
          })
        }
      />
    </div>
  )
}

export const TableHeaderCell = ({ text }: TextCellProps) => {
  return (
    <div tw="flex items-center justify-center w-40">
      <p tw="text-purple text-md font-bold text-center">{text}</p>
    </div>
  )
}
